const HtmlDecode = (content) => {
  // console.log(content)
  // let e = document.createElement("div");
  // e.innerHTML = content;
  // return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
  //   let temp = document.createElement("div");
  // temp.innerHTML = content;
  // return temp.textContent || temp.innerText || "";

  const div = document.createElement("span");
  div.innerHTML = content;
  const text = div.innerText; // Output: "Hello World"
  return text;
};

export default HtmlDecode;